import { useCallback } from "react";

import type { InputMaybe, ShortStayParamsInput } from "@/lib/gql/__generated__/graphql";

import type { ForAutoGenerator } from "@/components/features/_model/types/auto-generator-for-view-model";

type Props = {
	shortStayParams: ForAutoGenerator<
		| {
				maximumStayDates?: number | undefined;
		  }
		| null
		| undefined,
		""
	>;
	onSetViewModel: (
		values: {
			key: "shortStayParams";
			value: ForAutoGenerator<
				InputMaybe<ShortStayParamsInput> | undefined,
				"hotelID" | "planID" | "hotelPolicy" | "hotel"
			>;
		}[],
	) => void;
};

export const usePlanShortStayParams = ({ shortStayParams, onSetViewModel }: Props) => {
	const onSetShortStayParams = useCallback(
		(value: number | undefined) => {
			if (value === undefined) {
				onSetViewModel([
					{
						key: "shortStayParams",
						value: undefined,
					},
				]);
			} else {
				onSetViewModel([
					{
						key: "shortStayParams",
						value: {
							maximumStayDates: {
								isEdited: true,
								value: value,
							},
						},
					},
				]);
			}
		},
		[onSetViewModel],
	);

	return {
		shortStayParams,
		onSetShortStayParams,
	};
};
